export enum PHUrgencyOptions {
  within_next_week = 'Within the next week',
  within_next_month = 'Within the next month',
  within_next_few_months = 'Within the next few months',
  not_in_a_rush = "I'm not in a rush",
  dont_know_yet = "I don't know yet"
}
